import _get from 'lodash/get';
import store from '@/store';
import BigNumber from "bignumber.js";
import $moment from 'moment';
import { VueCookieNext } from 'vue-cookie-next';
import { tooth } from '@shining3d/utils';
import { useLang } from "@shining3d/common-module/utils/lang.js";
const { $t } = useLang( '@shining3d/app' );
const { $t: $txdo } = useLang( '@shining3d/xl-design-order' );
import { toothNameMap } from '../design/case/const.js';
import _intersection from 'lodash/intersection';

const cc = VueCookieNext.getCookie( 'cc' ) || 'CN';

// 地址拼接
function $getCdnUrl( imgObj, isImg ) {
	let cdnUrl = '';
	if ( !imgObj || !imgObj.bucket ) {
		return cdnUrl;
	}
	// 默认值修改
	const cdnUrlConfig = _get( window, 'app.global.cdnUrl', {});
	const cloud = _get( window, 'app.global.cloud', 'aliyun' );
	if ( !isImg ) {
		cdnUrl = cdnUrlConfig[ imgObj.bucket ] + imgObj.dfsID;
	}
	if ( cloud === 'aliyun' ) {
		cdnUrl = cdnUrlConfig[ imgObj.bucket ] + imgObj.dfsID;
	}
	if ( cloud === 'aws' ) {
		cdnUrl = cdnUrlConfig[ imgObj.bucket ] + '100xAUTO/' + imgObj.dfsID;
	}
	return cdnUrl;
}
// 价格展示：除以 100，没有两位小数的时候补全两位小数
function formatPrice( price, fixNum = 2) {
    const num = new BigNumber( price ).dividedBy(100);
    return num.toFixed( fixNum );
}

// 地区日期差格式化转换
function $convertUTCDateToLocalDate( sd, format = 'YYYY-MM-DD HH:mm:ss' ) {
	if ( !sd || Object.keys( sd ).length < 1 ) {
		return '';
	}
	// 时区差需要地区数据支撑
	let utcOffset = 0;
	const zones = store.state.countryList.find(( val ) => cc.toUpperCase() === val.id );
	if ( zones ) {
		try {
			utcOffset = JSON.parse( zones.timezones )[ 0 ].utcOffset;
		} catch ( error ) {
			console.log( error );
		}
	}
	return $moment.utc( sd ).utcOffset( utcOffset ).
		format( format );
}

// 地区日期差格式化转换（唯一区别 时区反向偏移）
function $convertLocalDateToUTCDate ( sd, format = 'YYYY-MM-DD HH:mm:ss' ) {
	if ( !sd || Object.keys( sd ).length < 1 ) {
		return '';
	}
	// 时区差需要地区数据支撑
	let utcOffset = 0;
	const zones = store.state.countryList.find(( val ) => cc.toUpperCase() === val.id );
	if ( zones ) {
		try {
			utcOffset = JSON.parse( zones.timezones )[ 0 ].utcOffset;
		} catch ( error ) {
			console.log( error );
		}
	}
	return $moment.utc( sd ).utcOffset( -utcOffset ).
		format( format );
}

const $getBlobByUrl = ( url ) => new Promise(( resolve, reject ) => {
	const xhr = new XMLHttpRequest();
	xhr.open( 'get', url, true );
	xhr.responseType = 'blob';
	xhr.onload = function () {
		if ( this.status === 200 ) {
			resolve( this.response );
		} else {
			reject( new Error( 'getBlobByUrl: network is error' ));
		}
	};
	xhr.send();
	xhr.onerror = () => {
		reject( new Error( 'getBlobByUrl: url is error' ));
	};
});

function convertTimeZone(originTime, originTimeZone) {
	if ( !originTime || !originTimeZone) {
		return;
	}

	// 将输入的时间字符串转换为 Date 对象
	const time = new Date(`2000-01-01T${originTime}:00Z`);
	
	let utcOffset = 0;
	const zones = store.state.countryList.find(( val ) => cc.toUpperCase() === val.id );
	if ( zones ) {
		try {
			utcOffset = JSON.parse( zones.timezones )[ 0 ].utcOffset;
		} catch ( error ) {
			console.log( error );
		}
	}

	// 计算目标时区和原始时区的时差（以分钟为单位）
	const timeDiff = utcOffset - Number(originTimeZone) * 60;
	
	// 将时间增加时差得到目标时区的时间
	time.setMinutes(time.getMinutes() + timeDiff);
	
	// 获取目标时区的小时和分钟
	const targetHour = time.getUTCHours();
	const targetMinute = time.getUTCMinutes();
	
	// 格式化输出目标时区的时间
	const targetTime = `${targetHour.toString().padStart(2, '0')}:${targetMinute.toString().padStart(2, '0')}`;
	
	return targetTime;
}

const $getToothSingType = ( type ) => {
	if ( type && type.includes( 'SDNT_' )) {
		return type.slice( 5 );
	} else {
		return type || 'FDI';
	}
};

const $transToothNumber = ( num, toType = 'FDI' ) => {
	if ( isNaN( num )) {
		return num;
	}
	// eslint-disable-next-line no-param-reassign
	toType = $getToothSingType( toType );
	if ( toType === 'Universal' ) {
		return tooth.getToothNumber( num, 'FDI', toType );
	}
	return num;
};

// 牙中文名称：全颌、上颌、下颌、具体牙号（FDI/UN转换）
const transToothName = ( tooth, toType = 'FDI' ) => {
	let showName = '';
    if (toothNameMap[tooth]) {
      showName = toothNameMap[tooth];
    } else {
      showName = $transToothNumber(Number(tooth), toType);
    }
    return showName;
};

// 牙号判断是否在上颌、下颌，根据FDI标记法的判断
const toothInUpOrLowerJaw = ( tooths = [] ) => {
	const allUpperJawNum = ['18', '17', '16', '15', '14', '13', '12', '11', '21', '22', '23', '24', '25', '26', '27', '28'];
	const allLowerJawNum = ['48', '47', '46', '45', '44', '43', '42', '41', '31', '32', '33', '34', '35', '36', '37', '38'];

	let inUpperJaw = !!_intersection(allUpperJawNum, tooths).length;
	let inLowerJaw = !!_intersection(allLowerJawNum, tooths).length;
	return {
		inUpperJaw,
		inLowerJaw
	}
};

// 模型文件列表转换
const transModelList = ( list ) => {
	let resTemp = list || [];
	resTemp = resTemp.map(( v ) => ({
		...v,
		attachName: v.fileName
	}));

	const paramsObj = {};
	const labelList = _get(window, 'app.global.imageCollectionEnums', []);
	labelList.forEach(( v, i ) => {
		paramsObj[ v.key ] = { name: $txdo( v.name ) };
		if ( v.children ) {
			paramsObj[ v.key ].childObj = {};
			v.children.forEach(( child, j ) => {
				paramsObj[ v.key ].childObj[ child.key ] = {
					name: $txdo( child.name ),
					type: child.type,
					sort: ( v.modelSort || i ) * 100 + ( child.modelSort || j )
				};
			});
		}
	});
	resTemp = resTemp.map(( v ) => {
		if ( v.classType && paramsObj[ v.classType ]) {
			if ( paramsObj[ v.classType ].childObj && v.detailType ) {
				if ( paramsObj[ v.classType ].childObj[ v.detailType ]) {
					v.attachTip = paramsObj[ v.classType ].childObj[ v.detailType ].name || $txdo('design.model.defaultJaw');
					v.type = paramsObj[ v.classType ].childObj[ v.detailType ].type;
					v.sort = paramsObj[ v.classType ].childObj[ v.detailType ].sort;
				}
				if ( v.classType === 'other' ) {
					v.attachTip = $t( 'button.download' );
					v.type = 'other';
				}
			}
		}
		return v;
	}).sort(( a, b ) => a.sort < b.sort ? -1 : 0 );

	return resTemp;
};
// 时间单位
const $timeUnit = (lang, unit, time ) => {
	let timeUnit = '';
	let useLang = lang === 'zh' || lang === 'zh-cn' ? 'zh' : 'en';
	if( unit && time){
		timeUnit = new Intl.NumberFormat(useLang, {
			style: "unit",
			unit: unit, unitDisplay: "long",
		}).format(time) 
	} else {
		timeUnit = '';
	}
	// 英文首字母大写
	timeUnit = timeUnit.replace('day', 'Day')
		.replace('hour', 'Hour')
		.replace('minute', 'Minute')
		.replace('second', 'Second');
	return timeUnit;
}

// 处理转换影像文件数据
const formatImageFile = (item) => {
    let acceptType = item.imageFileType ? item.imageFileType.split(',') : [];
    let suffix = acceptType.map(item => `.${item}`).join(',');
	let tip = $txdo('design.casefile.tip', {
		suffix: suffix
	});
    // 处理 any 的任意类型
	if ( suffix.includes('any')) {
		tip = $txdo('design.case.anyfile') || '支持任意类型';
		suffix = '',
		acceptType = []
	}
	const obj = {
        key: item.key,
        limit: item.limit,
        title: item.imageName,
        maxSize: item.imageSize,
        tip: $txdo('design.case.maxfileSize', { size: item.imageSize }) + tip, // `不超过${item.imageSize}M；` + tip
        accept: suffix,
		imageRemark: item.imageRemark,
		text: $txdo('design.case.addfileTip', { imageName: item.imageName}),  // `添加或拖入${item.imageName}`
		outOfSizeTip: $txdo('design.case.outOffSizeTip', { size: item.imageSize }),
		sort: item.sort || -1
    }
	if ( acceptType.length ) {
		obj.typeErrorList = acceptType
	}
    return obj;
};

const countDecimalPlaces = function (num = 0) {
    // 将数字转换为字符串
    const numStr = num.toString();
    // 查找小数点，如果不存在则返回-1
    const decimalIndex = numStr.indexOf('.');
    if (decimalIndex === -1) {
        return 0;
    }
    // 返回小数位数
    return numStr.length - decimalIndex - 1;
};

const $importImg = ( imgPath ) => {
	try {
		// new URL( `../assets/image/${imgPath}`, import.meta.url ).href
	} catch(e){

	}
	
};
const $openUrl = ( url, target = '_blank' ) => {
	if ( !url ) {
		return;
	}
	const link = document.createElement( 'a' );
	link.target = target;
	link.style.display = 'none';
	link.href = url;
	document.body.appendChild( link );
	link.click();
	document.body.removeChild( link );
};

export {
    $getCdnUrl,
    formatPrice,
    $convertUTCDateToLocalDate,
    $getBlobByUrl,
	convertTimeZone,
	$getToothSingType,
	$transToothNumber,
	transModelList,
	$convertLocalDateToUTCDate,
	$timeUnit,
	transToothName,
	formatImageFile,
	countDecimalPlaces,
	$importImg,
	$openUrl,
	toothInUpOrLowerJaw
}

